import cookie from './cookie';
/**
 * 获取cookie
 */
export var getCookie = function (key) {
    return cookie.getItem(key);
};
/**
 * 设置cookie
 */
export var setCookie = function (key, value, days) {
    cookie.setItem(key, value, days);
};
export var removeCookie = function (key) {
    cookie.removeItem(key);
};
/**
 * 获取本地存储
 */
export var getStorage = function (key) {
    if (!key)
        return false;
    return localStorage[key] ? JSON.parse(localStorage[key]) : '';
};
/**
 * 设置本地存储
 */
export var setStorage = function (key, value) {
    if (!key && !value)
        return false;
    value = JSON.stringify(value);
    localStorage[key] = value;
};
/**
 * 移除本地存储
 */
export var removeStorage = function (key) {
    if (!key)
        return false;
    localStorage.removeItem(key);
};
/**
 * 获取本地存储
 */
export var getSession = function (key) {
    if (!key)
        return false;
    return sessionStorage[key] ? JSON.parse(sessionStorage[key]) : false;
};
/**
 * 设置本地存储
 */
export var setSession = function (key, value) {
    if (!key && !value)
        return false;
    value = JSON.stringify(value);
    sessionStorage[key] = value;
};
/**
 * 移除本地存储
 */
export var removeSession = function (key) {
    if (!key)
        return false;
    return sessionStorage.removeItem(key);
};
/**
 *  区分是浏览器打开还是app内打开（利用useragent,android约定返回字符串location-android,ios返回location-ios）
 */
export var isApp = function () {
    var UA = navigator.userAgent.toLowerCase(); // crm-android ,crm-ios
    if (UA === 'location-android') {
        return true;
    }
    else if (UA === 'location-ios') {
        return true;
    }
    else {
        return false;
    }
};
/**
 *  是否andriod app
 */
export var isAppAndriod = function () {
    var UA = navigator.userAgent.toLowerCase(); // crm-android ,crm-ios
    return (UA === 'location-android');
};
/**
 *  是否ios app
 */
export var isAppIOS = function () {
    var UA = navigator.userAgent.toLowerCase(); // crm-android ,crm-ios
    return (UA === 'location-ios');
};
/**
 * @description: 对json数组数据以符号分隔显示为字符串
 * @param {type} data      json数组数据，如 data = [{ id: 1, name: '张三' }]
 * @param {type} key       提取的键值，如 key = 'name'
 * @param {type} separator 用于分割的符号，如 separator = '、'
 * @return:
 */
export function parseArrayJsonToString(data, key, separator) {
    if (data === void 0) { data = []; }
    if (key === void 0) { key = 'name'; }
    if (separator === void 0) { separator = '、'; }
    var result = '';
    if (data && Array.isArray(data)) {
        result = data.map(function (item) { return item[key]; }).join(separator);
    }
    return result;
}
/**
 * 清除ios机型下高德地图的iframe带来的router返回上一步的问题
 */
export function eliminateIframeEffects(el) {
    if (isAppIOS()) {
        var iframe = el.querySelector('iframe');
        iframe && iframe.parentNode.removeChild(iframe);
    }
}
/**
 *  是否是企微环境
 */
export var isWeComEnv = function () {
    return window.navigator.userAgent.toLowerCase().includes('wxwork');
};
